<div class="row mt-n1">
    <div class="col-md-12">
        <div class="card card-accent-success">
            <div class="card-header-buscador">
                <i class="fa fa-align-justify"></i> {{ title }}
            </div>
    
            <div class="card-body-grid" *ngIf="result">
                <!-- 
                 Si éste componente está dentro de una ventana de diálogo:
                    Dado que en TwCultivoCollection solo llega un cultivo, tomamos como en dataKey para el expanded el IdCultivo y no el campo Id.
                    Si se da el caso, que se devuelven "n" cultivos del mismo recinto, 
                    si indicásemos el campo Id en dataKey, que es el IdRecinto, se expanderían todas las filas del mismo recinto -->
                <p-table #tableSearch autoLayout="true" [value]="result?.ResultList" [lazy]="true"
                    [rowExpandMode]="mode !== dialogMode.Basic ? 'single': 'none'"
                    dataKey="Id"
                    [lazyLoadOnInit]="false" [rowHover]="true"
                    (onLazyLoad)="onSearchLazy($event)" [paginator]="true" [columns]="cols"
                    [rows]="result?.PageSize" sortOrder="0"
                    [totalRecords]="result?.TotalCount" [loading]="loading"
                    [ngClass]="displayGridHidden(result.ResultList)"
                    styleClass="table table-responsive-sm table-striped table-sm">
    
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th scope="col" *ngFor="let col of columns" [ngClass]="{ 'th-xs': col.reduce }" [ngStyle]="{'display': col.display}"
                                    [pSortableColumn]="col.field">
                                    {{col.header}}
                                    <p-sortIcon *ngIf="col.field !== 'Link' && col.field !== 'ExpandLink'" [field]="col.field"></p-sortIcon>
                                </th>
                            </tr>
                        </ng-template>
    
                        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex" let-expanded="expanded">
                            <tr>
                                <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [ngClass]="{ 'td-xs': col.reduce }">
                                    <div *ngIf="mode !== dialogMode.Basic && col.field === 'ExpandLink'" class="btn-group">
                                        <span>
                                            <a href="#" class="btn button-row-expand align-chevron" [pRowToggler]="rowData" 
                                                [title]="expanded ? 'Colapsar cultivos del recinto' : 'Expandir cultivos del recinto '+ rowIndex"
                                                [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                                            </a>
                                        </span>
                                    </div>
                                    <span *ngIf="col.field !== 'Link' && col.field !== 'ExpandLink' && col.field !== 'SuperficieTotal'">
                                        {{ rowData[col.field] }}
                                    </span>
                                    <span *ngIf="col.field === 'SuperficieTotal'">
                                        {{ rowData[col.field] | number:'1.2-5':'es-ES' }}
                                    </span>
                                    <div *ngIf="col.field === 'Link'">
                                        <div *ngIf="mode === dialogMode.Basic" class="btn-group">
                                            <button (click)="onEdit(rowData)" type="button" [disabled]="readonly" class="btn btn-sm btn-warning" title="Editar">
                                                <span class="fa fa-edit"></span>
                                            </button>
                                        </div>
                                        <ng-container *ngIf="mode === dialogMode.Embedded">
                                            <!-- El modo embebido se utiliza por ejemplo para mostrar los recintos-cultivos seleccionados en una solicitud o en una UI -->
                                            <div class="btn-group">
                                                <button (click)="onView(rowData)" type="button" class="btn btn-sm btn-info" title="Consultar Recinto">
                                                    <span class="fa fa-eye"></span>
                                                </button>
                                            </div>
                                        </ng-container>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns">
                            <tr>
                                <td [attr.colspan]="columns.length + 1">
                                    <table class="table-subtable">
                                        <thead class="table-subtable-thead">
                                            <tr>
                                                <th class="th-md">&nbsp;</th>
                                                <th>Identificador</th>
                                                <th>Especie/Nombre Común</th>
                                                <th>Nombre Científico</th>
                                                <th>Variedad</th>
                                                <th>Código Eppo</th>
                                                <th>Superficie Variedad (ha)</th>
                                                <th>Prod. estimada (kg)</th>
                                                <th>Grupo</th>
                                                <th>Forma</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let cultivo of rowData['TwCultivoCollection']">
                                                <td>
                                                    <span *ngIf="cultivo.Desautorizado" class="fa fa-ban" [ngbTooltip]="showDesautorizadasMessage(cultivo)"></span>
                                                    <ng-container *ngIf="mode === dialogMode.Dialog">
                                                        <p-tableCheckbox [value]="cultivo" (click)="onSelect($event, rowData, cultivo)"></p-tableCheckbox>
                                                    </ng-container>
                                                    <ng-container *ngIf="mode === dialogMode.Embedded">
                                                        <div *ngIf="!readonly && (!cultivo?.MarkToDelete || cultivo?.MarkToDelete === undefined)" class="btn-group">
                                                            <button (click)="onDelete(cultivo)" type="button" [disabled]="readonly" class="btn btn-sm btn-danger" title="Descartar Cultivo">
                                                                <span class="fa fa-remove"></span>
                                                            </button>
                                                        </div>
                                                        <div *ngIf="cultivo?.MarkToDelete" class="btn-group">
                                                            <button (click)="onUndoDelete(cultivo)" type="button" [disabled]="readonly" class="btn btn-sm btn-warning" title="Deshacer Descartar">
                                                                <span class="fa fa-undo"></span>
                                                            </button>
                                                        </div>
                                                    </ng-container>                                         
                                                </td>
                                                <td>{{ cultivo?.Identificador }}</td>
                                                <td>{{ cultivo?.NombreComun }}</td>
                                                <td>{{ cultivo?.NombreCientifico }}</td>
                                                <td>{{ cultivo?.Variedad }}</td>
                                                <td>{{ cultivo?.CodigoEppo }}</td>
                                                <td>{{ cultivo?.SuperficieVariedad | number:'1.2-5':'es-ES' }}</td>
                                                <td>{{ cultivo?.ProduccionEstimada | number:'1.2-5':'es-ES'  }}</td>
                                                <td>{{ cultivo?.Grupo }}</td>
                                                <td>{{ cultivo?.Forma }}</td>
                                            </tr>

                                            <tr *ngIf="rowData['TwCultivoCollection'] === [] || rowData['TwCultivoCollection'] === undefined || rowData['TwCultivoCollection'] === null">
                                                <td colspan="9">No hay cultivos disponibles</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </ng-template>

                    </p-table>
                    
                <div class="empty-grid" *ngIf="result?.ResultList?.length === 0">No se ha encontrado ningún recinto</div>
                <div *ngIf="result?.ResultList?.length === 1" class="p-2">Se ha encontrado {{ result?.ResultList?.length | number:'1.0-0':'es-ES' }} recinto</div>
                <div *ngIf="result?.ResultList?.length > 1" class="p-2">Se han encontrado {{ result?.TotalCount | number:'1.0-0':'es-ES' }} recintos</div>
            </div>
    
        </div>
    </div>
</div>
